// tslint:disable: max-line-length triple-equals
import React, { useEffect, useState } from 'react';
import Icon from 'lqa-ui/lib/Components/Icon';
import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { clear, getItem, setItem } from '../../utils/localStorage';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  acceptLQATerms,
  addUserActivate,
  getDepartmentForUser,
  updateToken,
} from './../../requests/profile';
import { showErrorMessage } from '../../helpers/showMessage';
import TermsService from '../TermsServicePilotCreate';
import {
  convertToTitleCaseAndCapitalizeFirst,
  isUnauthorized,
} from '../../utils/common';
import { ClearAllIndexedDB } from '../../indexed';
import { FooterWarningConsent } from '../../app/common/sharedComponents/FooterWarningConsent';
import { NotLoggedInHeader } from './../../app/common/sharedComponents/NotLoggedInHeader';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { PhoneContainer } from './../../app/common/sharedStyledComponents/PhoneInput.styled';

import {
  HeaderSection,
  Title,
  RegisterFormWrapper,
  Divider,
  UserRole,
  RoleType,
  TopSection,
  FooterWarningConsentWrapper,
  FooterWarningConsentOptionsContainer,
  ButtonBlockWrapper,
  FieldContent,
  ErrorLine,
  ErrorContainer,
} from './CreateProfile.styled';
import { SPECIAL_CHARACTERS_REGEX, PASSWORD_REGEX_MIN_8_WITH_NUMBER } from '../../utils/regex';
import { Body4, Headline4 } from './../../app/common/typography';

interface IRegisterUser {
    userFirstName: string;
    userLastName: string;
    hotelId?: string;
    departmentId?: string;
    jobTitle: string;
    level: string;
    email?: string;
    contactPhone?: string;
    userPassword?: string;
    confirmUserPassword?: string;
}

const CreateProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [isRegister, setIsregister] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const loc: any = { ...location };
  const userData = loc.state.user;
  const accessToken = loc.state.accessToken;
  const token = loc.state.token;
  const isDeactivatedUser: any | null =
    (loc && loc.state && loc.state.isDeactivatedUser) || false;

  const [form, setForm] = useState<IRegisterUser>({
    userFirstName: userData.userFirstName,
    userLastName: userData.userLastName,
    jobTitle: convertToTitleCaseAndCapitalizeFirst(userData.userRole),
    level: convertToTitleCaseAndCapitalizeFirst(userData.level),
    email: userData.userEmail,
    contactPhone: userData.userPhone,
  });

  const handleCheckboxChange = () => {
    setCheckboxChecked(!checkboxChecked);
  };

  const handleSubmit = async () => {
    if (checkboxChecked == false) {
      setIsregister(true);
      return false;
    }

    if (userData.isPasswordSet && !isDeactivatedUser) {
      setIsLoading(true);
      acceptLQATerms(accessToken)
      .then((data) => {
        if (userData && userData.userEmail) {
          localStorage.setItem('email', userData.userEmail);
        } else if (userData && userData.userPhone) {
          // made changes here
          localStorage.setItem('phonenumber', userData.userPhone);
        }
        navigate('/myLQAProfile', {
          state: {
            id: userData.id,
            accessToken,
            hotelName: userData.brands[0].hotels[0].name,
            userData,
          },
        });
      }).finally(() => {
        setIsLoading(false);
      });

    }

    if (
      !userData.isPasswordSet &&
      (form.userPassword === '' ||
        form.confirmUserPassword === '' ||
        !(form.userPassword === form.confirmUserPassword))
    ) {
      showErrorMessage('Please fill all data');
      return;
    } else if (form.userPassword && !SPECIAL_CHARACTERS_REGEX.test(form.userPassword)) {
      showErrorMessage('It is mandatory to have at least one of the following Special Characters: !@#$%^&*(),.?":{}|<>');
      return;
    } else if (form.userPassword && !PASSWORD_REGEX_MIN_8_WITH_NUMBER.test(form.userPassword)) {
      showErrorMessage('It is mandatory to have minimum 8 characters with at least one numnber');
      return;
    }

    const payLoad = {
      token,
      password: form.userPassword,
    };
    if (!userData.isPasswordSet) {
      updateToken(payLoad, accessToken)
        .then(async (resp) => {
          if (resp) {
            if (!isDeactivatedUser) {
              await acceptLQATerms(accessToken);
              if (userData && userData.userEmail) {
                localStorage.setItem('email', userData.userEmail);
              } else if (userData && userData.userPhone) {              
                localStorage.setItem('phonenumber', userData.userPhone);
              }
              navigate('/myLQAProfile', {
                state: {
                  id: userData.id,
                  accessToken,
                  hotelName: userData.brands[0].hotels[0].name,
                  userData,
                },
              });
            } else {
              await addUserActivate(token);
              await acceptLQATerms(accessToken);
              ClearAllIndexedDB();
              const userData = getItem('user');
              const userProfile = getItem('userProfile');
              const isUserIgnoredPin = getItem('isUserIgnoredPin')
                ? getItem('isUserIgnoredPin')
                : undefined;
              const selectedHotelId = getItem('selectedHotel');
              const selectedClientId = getItem('selectedClient');
              clear();
              setItem('isUserIgnoredPin', isUserIgnoredPin);

              let userEmail: string = '';
              if (userData && userData.user && userData.user.userEmail) {
                userEmail = userData.user.userEmail.trim().toLowerCase();
              } else {
                if (userProfile && userProfile.userEmail) {
                  userEmail = userProfile.userEmail.trim().toLowerCase();
                }
              }
              if (userEmail) {
                localStorage.setItem('email', userEmail);
              }
              if (userData && userData.userPhone) {
                localStorage.setItem('phonenumber', userData.userPhone);
              }
              setItem('selectedHotel', selectedHotelId);
              setItem('selectedClient', selectedClientId);
              window.location.href = `register-success/register`;
            }
          }
        })
        .catch((e) => {
          showErrorMessage('Something went wrong');
        });
    } else {
      await addUserActivate(token);
      await acceptLQATerms(accessToken);
      ClearAllIndexedDB();
      const userData = getItem('user');
      const userProfile = getItem('userProfile');
      const isUserIgnoredPin = getItem('isUserIgnoredPin')
        ? getItem('isUserIgnoredPin')
        : undefined;
      const selectedHotelId = getItem('selectedHotel');
      const selectedClientId = getItem('selectedClient');
      clear();
      setItem('isUserIgnoredPin', isUserIgnoredPin);

      let userEmail: string = '';
      if (userData && userData.user && userData.user.userEmail) {
        userEmail = userData.user.userEmail.trim().toLowerCase();
      } else {
        if (userProfile && userProfile.userEmail) {
          userEmail = userProfile.userEmail.trim().toLowerCase();
        }
      }
      if (userData && userData.user && userData.user.isPinSet) {
        localStorage.setItem('isPinSet', userData.user.isPinSet);
      } else if (userProfile && userProfile.isPinSet) {
        localStorage.setItem('isPinSet', userProfile.isPinSet);
      }
      if (userEmail) {
        localStorage.setItem('email', userEmail);
      }
      if (userData && userData.userPhone) {
        localStorage.setItem('phonenumber', userData.userPhone);
      }
      localStorage.setItem('selectedHotel', selectedHotelId);
      localStorage.setItem('selectedClient', selectedClientId);
      window.location.href = `register-success/register`;
    }
    return;
  };

  useEffect(() => {
    getDepartmentForUser(userData.id, accessToken)
      .then((res) => {
        if (res && res.length < 1) {
          setForm({ ...form, departmentId: 'All' });
        } else {
          let str = '';
          res.map((o, i) => {
            str = str + o.value + ', ';
          });
          setForm({ ...form, departmentId: str });
        }
      })
      .catch((res) => {
        showErrorMessage(
          'Unable to retrieve Department for User',
          !isUnauthorized(res)
        );
      });
  }, []);

  return (
    <>
      <TopSection>
        <NotLoggedInHeader
          isRegistering={true}
          step={2}
          isDeactivatedUser={isDeactivatedUser}
        />
      </TopSection>
      <RegisterFormWrapper>
        <HeaderSection>
          <Title>Register with {userData.brands[0].hotels[0].name}</Title>
          <Headline4 color="eerieBlack">
            {form.userFirstName} {form.userLastName}
          </Headline4>
          <Divider />
          <UserRole>
            {form.jobTitle} {form.level && `(${form.level})`}
          </UserRole>
          {form.departmentId && <RoleType>{form.departmentId}</RoleType>}
        </HeaderSection>
        {userData.userEmail && form.email && (
          <FieldContent>
            <Body4 color="dimGray">Contact Information</Body4>
            <ControlInput
              label="Email"
              name="email"
              value={form.email}
              required={true}
              hasError={false}
              disabled={true}
            />
          </FieldContent>
        )}
        {userData.userPhone && (
          <PhoneContainer>
            <PhoneInput
              country={'us'}
              value={form.contactPhone && form.contactPhone}
              dropdownClass={'phone-input-dropdown'}
              disabled={true}
            />
          </PhoneContainer>
        )}
        {!userData.isPasswordSet && (
          <>
            <FieldContent>
              <Body4 color="dimGray">Create Your password</Body4>
              <ControlInput label="hidden" value={''} className="hide" />
              <ControlInput
                label="Password"
                name="password"
                value={form.userPassword || ''}
                onChange={(e) => {
                  setForm({ ...form, userPassword: e.target.value });
                }}
                required={true}
                hasError={false}
                disabled={false}
                secureTextEntry={true}
                revealPasswordAddOn={true}
              />
            </FieldContent>
            <FieldContent>
              <Body4 color="dimGray">Confirm password</Body4>
              <ControlInput label="hidden" value={''} className="hide" />
              <ControlInput
                label="Password"
                name="password"
                value={form.confirmUserPassword || ''}
                onChange={(e) => {
                  setForm({ ...form, confirmUserPassword: e.target.value });
                }}
                required={true}
                hasError={false}
                disabled={false}
                secureTextEntry={true}
                revealPasswordAddOn={true}
              />
              <ErrorContainer>
                <ErrorLine>
                  <Icon
                    kind={
                      form.userPassword && PASSWORD_REGEX_MIN_8_WITH_NUMBER.test(form.userPassword) ? 'status-success' : 'clear'
                    }
                    width={13}
                    height={13}
                  />
                  <Body4 color="battleShipGray">
                    Password should be at least 8 Character long and Numbers
                  </Body4>
                </ErrorLine>
                <ErrorLine>
                  <Icon
                    kind={
                      form.userPassword && SPECIAL_CHARACTERS_REGEX.test(form.userPassword)
                        ? 'status-success'
                        : 'clear'
                    }
                    width={13}
                    height={13}
                  />
                  <Body4 color="battleShipGray">                
                    Special Characters - !@#$%^&*(),.?":{}|&lt;&gt;
                  </Body4>
                </ErrorLine>
                <ErrorLine>
                  <Icon
                    kind={
                      form.userPassword &&
                      form.userPassword === form.confirmUserPassword
                        ? 'status-success'
                        : 'clear'
                    }
                    width={13}
                    height={13}
                  />
                  <Body4 color="battleShipGray"> Password must match </Body4>
                </ErrorLine>
              </ErrorContainer>
            </FieldContent>
          </>
        )}
        <FooterWarningConsentWrapper>
          <TermsService
            checkboxChecked={checkboxChecked}
            onCheckboxChange={handleCheckboxChange}
            isRegister={isRegister}
          />
          <FooterWarningConsentOptionsContainer>
            <FooterWarningConsent />
          </FooterWarningConsentOptionsContainer>
        </FooterWarningConsentWrapper>

        <ButtonBlockWrapper>
          <ButtonLarge
            title={!isDeactivatedUser ? 'Register' : 'Activate App Account'}
            onClick={handleSubmit}
            loading={isLoading}
            disabled={(!form.userPassword || userData.isPasswordSet) && !checkboxChecked}
          />
        </ButtonBlockWrapper>
      </RegisterFormWrapper>
    </>
  );
};

export default CreateProfile;
